import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks when a user enables/disables session duration',
  name: 'enabled_or_disabled_session_duration',
  params: [
    {
      description: 'binary value captures whether feature was enabled or disabled',
      name: 'session_duration_enabled',
      required: true,
      type: 'boolean',
    },
    {
      description: 'Duration period (in seconds)',
      name: 'session_duration_time',
      required: false,
      type: 'number',
    },
  ],
};

export default META;
